export const allocationsTableColumns = [
  { title: 'Strategy', key: 'name', width: 26, keySort: 'name' },
  { title: 'Status', key: 'status', width: 12, keySort: 'status' },
  { title: 'Asset Class', key: 'assetClass', width: 12, keySort: 'asset class' },
  { title: 'Investor Docs Due', key: 'investorDocsDue', width: 12, keySort: 'investor docs due' },
  { title: 'Minimum', key: 'minimum', width: 12, keySort: 'minimum' },
  { title: 'Criteria', key: 'suitability', width: 22, keySort: 'criteria' },
  { title: ' ', key: ' ', width: 4 }
];

export const allocationsMobileTableSort = [
  {
    title: 'Strategy • A -> Z',
    key: 'name',
    asc: true
  },
  {
    title: 'Strategy • Z -> A',
    key: 'name',
    asc: false
  },
  {
    title: 'Status • A -> Z',
    key: 'status',
    asc: true
  },
  {
    title: 'Status • Z -> A',
    key: 'status',
    asc: false
  },
  {
    title: 'Asset Class • A -> Z',
    key: 'assetClass',
    asc: true
  },
  {
    title: 'Asset Class • Z -> A',
    key: 'assetClass',
    asc: false
  },
  {
    title: 'Final Close • Newest -> Oldest',
    key: 'finalClose',
    asc: false
  },
  {
    title: 'Final Close • Oldest -> Newest',
    key: 'finalClose',
    asc: true
  },
  {
    title: 'Minimum • Max -> Min',
    key: 'minimum',
    asc: false
  },
  {
    title: 'Minimum • Min -> Max',
    key: 'minimum',
    asc: true
  },
  {
    title: 'Criteria • Earlier -> Later',
    key: 'suitability',
    asc: false
  },
  {
    title: 'Criteria • Later -> Earlier',
    key: 'suitability',
    asc: true
  }
];
